<template>
  <div
    class="a4-page"
    style="
      position: relative;
      background-color: var(--color-white);
      border: 1px solid var(--color-light-gray);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      width: 100%;
      aspect-ratio: 1/1.414;
      padding: 40px;
      overflow: hidden;
    "
  >
    <!-- Monthly Coverage -->
    <monthly-coverage-section
      v-if="shouldShowMonthlyCoverage"
      :project-data="projectData"
      :include-sections="includeSections"
      :payment-type="paymentType"
      :report-type="reportType"
    />

    <!-- Price Section -->
    <price-section
      v-if="shouldShowPrice"
      :project-data="projectData"
      :payment-type="paymentType"
      :report-type="reportType"
    />

    <!-- Date and Signature Section -->
    <date-signature-section
      v-if="shouldShowSignature"
      :report-type="reportType"
    />

    <!-- Footer -->
    <report-footer :report-type="reportType" />

    <!-- Page Number -->
    <div class="position-absolute bottom-0 end-0" style="padding: 20px 40px">
      <small class="text-muted" style="font-size: 12px">3</small>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from "vue";
import type { Project } from "@/types/projectTypes";
import MonthlyCoverageSection from "../sections/MonthlyCoverageSection.vue";
import PriceSection from "../sections/PriceSection.vue";
import DateSignatureSection from "../sections/DateSignatureSection.vue";
import ReportFooter from "../sections/ReportFooter.vue";

export default defineComponent({
  name: "ReportPage3",
  components: {
    MonthlyCoverageSection,
    PriceSection,
    DateSignatureSection,
  },
  props: {
    projectData: {
      type: Object as PropType<Project | null>,
      required: true,
    },
    includeSections: {
      type: Object as PropType<Record<string, boolean>>,
      required: true,
    },
    paymentType: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const reportType = computed(() => {
      if (props.projectData?.service_type === "complete_solution") {
        return `${props.projectData.service_type}.${props.paymentType}`;
      }
      return props.projectData?.service_type || "product_supply";
    });

    const shouldShowMonthlyCoverage = computed(() => {
      return (
        props.projectData?.service_type === "complete_solution" &&
        props.paymentType === "installment"
      );
    });

    const shouldShowPrice = computed(() => {
      return (
        (props.projectData?.service_type === "complete_solution" &&
          props.paymentType === "installment") ||
        (props.projectData?.service_type === "complete_solution" &&
          props.paymentType === "one_time")
      );
    });

    const shouldShowSignature = computed(() => {
      return (
        (props.projectData?.service_type === "complete_solution" &&
          props.paymentType === "installment") ||
        (props.projectData?.service_type === "complete_solution" &&
          props.paymentType === "one_time")
      );
    });

    return {
      reportType,
      shouldShowMonthlyCoverage,
      shouldShowPrice,
      shouldShowSignature,
    };
  },
});
</script>
